{
  "accountScreen": {
    "downloadCta": "تحميل الملف الموقع",
    "helpDescription": "راسلنا عبر البريد الإلكتروني <underline>{{email}}</underline>",
    "helpTitle": "هل تحتاج مساعدة أو لديك أسئلة؟",
    "loggedInWith": "تم تسجيل الدخول بواسطة {{method}}",
    "title": "الحساب",
    "usernameLoginMethod": "اسم المستخدم"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "إضافة فرد آخر",
    "addingMemberDescription": "نريد معرفة جميع أفراد أسرتك.",
    "addingMemberTitle": "أخبرنا عنهم",
    "age": "العمر",
    "coverageCheck": {
      "dateOfBirth": "تاريخ الميلاد (اختياري)",
      "description": "اختياري. هذا يساعدنا في العثور على تغطية قد تكون لديهم بالفعل.",
      "medicaidId": "رقم Medicaid (اختياري)",
      "medicaidIdPlaceholder": "أدخل رقم Medicaid",
      "ssn": "رقم الضمان الاجتماعي (اختياري)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "ساعدنا في التحقق من تغطيتهم"
    },
    "duplicateDialog": {
      "cancel": "لا، العودة",
      "checkError": "لم نتمكن من التحقق من أفراد أسرتك. يرجى المحاولة مرة أخرى.",
      "confirm": "نعم، شخص آخر",
      "description": "لقد أضفت <bold>{{name}}</bold> بالفعل. هل الشخص الذي تضيفه الآن شخص آخر؟",
      "descriptionWithDetails": "لقد أضفت <bold>{{name}}</bold> ({{details}}) بالفعل. هل الشخص الذي تضيفه الآن شخص آخر؟",
      "reminder": "لا حاجة لإضافة أي شخص سبق أن أضفته.",
      "title": "هل هذا شخص جديد؟"
    },
    "enterDateOfBirth": "أدخل تاريخ الميلاد بدلاً من ذلك",
    "enterRelationship": "أدخل صلة القرابة",
    "firstName": "الاسم الأول",
    "formSubmission": {
      "error": "لم نتمكن من إضافة هذا الفرد للأسرة. يرجى المحاولة مرة أخرى.",
      "success": "تمت إضافة {{firstName}} بنجاح"
    },
    "lastName": "اسم العائلة",
    "livingWithMe": "يعيش معي",
    "relationshipToMe": "صلة القرابة بي",
    "sameMailingAddress": "نفس عنوان المراسلة",
    "updateFormSubmission": {
      "success": "تم تحديث بيانات {{firstName}} بنجاح"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "يرجى إدخال إما الفئة العمرية أو تاريخ الميلاد.",
      "futureDateOfBirth": "الرجاء إدخال تاريخ ميلاد في أو قبل اليوم.",
      "invalidDateOfBirth": "يرجى إدخال تاريخ ميلاد صحيح (شهر/يوم/سنة).",
      "selectAnOption": "يرجى اختيار أحد الخيارات.",
      "specifyRelationship": "يرجى توضيح علاقة هذا الشخص بك."
    }
  },
  "appFooter": {
    "partnershipLabel": "بالشراكة مع"
  },
  "appHeader": {
    "toggleThemeTooltip": "تبديل المظهر مؤقت للتجربة فقط. يظهر فقط في بيئات التطوير."
  },
  "appMenu": {
    "account": "الحساب",
    "household": "الأسرة",
    "language": "اللغة",
    "logout": "تسجيل الخروج"
  },
  "applicantDocuments": {
    "alsoCompleted": "أكمل هذا المستند أيضاً {{section}}.",
    "alsoCompletedResidenceForMembers": "أكمل هذا المستند أيضاً {{section}} لأفراد الأسرة الذين يعيشون في نفس العنوان",
    "deleteDialog": {
      "description": "هل أنت متأكد أنك تريد حذف هذا المستند؟ لا يمكن التراجع عن هذا الإجراء.",
      "title": "حذف المستند"
    },
    "deleteToast": {
      "error": "لم نتمكن من حذف هذا المستند. يرجى المحاولة مرة أخرى.",
      "success": "تم حذف المستند بنجاح"
    },
    "immigrationIncomplete": {
      "description": "لا يزال عليك رفع رقم USCIS، أو مستندات وموافقات الهجرة، أو I-20 لإكمال {{section}}.",
      "dismiss": "حسناً",
      "title": "مطلوب مستند إضافي واحد"
    },
    "optional": "اختياري",
    "progress": "تم إكمال {{completeCount}} من {{applicableCount}}",
    "selectDocumentType": "اختر نوع المستند",
    "ssn": {
      "cardOption": "أو ارفع بطاقة الضمان الاجتماعي الخاصة بك",
      "label": "رقم الضمان الاجتماعي",
      "save": "حفظ",
      "saveError": "لم نتمكن من حفظ هذا الرقم. يرجى المحاولة مرة أخرى.",
      "saved": "تم حفظ رقم الضمان الاجتماعي"
    },
    "supportedFiles": "أنواع الملفات المدعومة: PDF, JPG, PNG",
    "upload": {
      "failed": "لم نتمكن من رفع هذا المستند. يرجى المحاولة مرة أخرى.",
      "failedDescription": "لم نتمكن من قراءة هذا الملف. يرجى حذفه ورفع نسخة جديدة.",
      "uploading": "جاري التحميل..."
    },
    "uploadOne": "حمل <bold>واحدًا على الأقل:</bold>"
  },
  "applicationAddressScreen": {
    "description": "يرجى مراجعة وتأكيد عناوين السكن والمراسلة لجميع أفراد الأسرة.",
    "homeAddress": "عنوان السكن",
    "isHomeless": "لا يوجد عنوان سكن ثابت",
    "mailingAddress": "عنوان المراسلة",
    "needsHomeAddress": "<italic>يحتاج إلى عنوان سكن</italic>",
    "needsMailingAddress": "<italic>يحتاج إلى عنوان مراسلة</italic>",
    "noMailingAddress": "لا يوجد عنوان مراسلة",
    "sameHomeAddress": "نفس عنوان السكن",
    "sameMailingAddress": "نفس عنوان المراسلة",
    "title": "معلومات العنوان",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "عنوان السكن",
      "addressTypeHomeAndMailing": "عنوان السكن والمراسلة",
      "addressTypeMailing": "عنوان المراسلة",
      "description_one": "{{householdName}} و{{count}} آخر يشاركونك حاليًا {{addressType}}. هل تريد تحديث عناوينهم أيضًا؟",
      "description_other": "{{householdName}} و{{count}} آخرين يشاركونك حاليًا {{addressType}}. هل تريد تحديث عناوينهم أيضًا؟",
      "description_zero": "{{householdName}} يشاركك حاليًا {{addressType}}. هل تريد تحديث عنوانهم أيضًا؟",
      "onlyUpdateMine": "لا، قم بتحديث عنواني فقط",
      "title": "تحديث عناوين أفراد الأسرة",
      "updateMembers_one": "تحديث {{count}} عضو",
      "updateMembers_other": "تحديث {{count}} أعضاء"
    },
    "you": "{{name}} (أنت)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "يجب أن <bold>يعيش الأطفال مع فرد الأسرة</bold> لأكثر من <bold>نصف العام</bold>، ويجب أن <bold>يوفر فرد الأسرة أكثر من نصف</bold> نفقاتهم السنوية (الغذاء، السكن، الدراسة، والفواتير الطبية). يشمل ذلك الأقارب غير البيولوجيين.",
    "title": "هل يعيش أفراد الأسرة التاليون مع أطفال دون سن 19 ويرعونهم؟"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "هل <bold>{{householdMembersNames}}</bold> جميعهم مواطنون أمريكيون؟",
    "hintDescription": "إذا اخترت <bold>لا</bold>، فلا تقلق. هناك خيارات أخرى متاحة بناءً على وضع الهجرة.",
    "noDescription": "البعض أو الجميع ليسوا مواطنين أمريكيين",
    "title": "أهلية الطلب",
    "yesDescription": "الجميع مواطنون أمريكيون"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "اختر «نعم، قم بتوصيلي» للحصول على المساعدة في البقاء مع أطبائك وتغطية عائلتك في مكان واحد.",
      "summaryWithMedicaid": "سنراجع طلب Medicaid الخاص بك ونتواصل معك إذا احتجنا إلى أي شيء. ستظل بحاجة إلى وكيل تأمين مرخص لإتمام التسجيل في {{programs}}.",
      "summaryWithoutMedicaid": "لدينا ما أرسلته. ستظل بحاجة إلى وكيل تأمين مرخص لإتمام التسجيل في {{programs}}.",
      "title": "لقد اخترت عدم التواصل مع وكيل تأمين مرخص. هل أنت متأكد؟"
    },
    "continueButton": "متابعة",
    "description": "سيراجع فريقنا طلباتك وسيتواصل معك إذا احتجنا إلى أي شيء. وبمجرد أن يصبح كل شيء جاهزًا، سنرسلها إلى البرامج التي اخترتها.",
    "title": "لقد استلمنا طلباتك!"
  },
  "applicationCoverageStatusScreen": {
    "description": "هل لدى <bold>{{householdMembersNames}}</bold> تأمين صحي أو تغطية صحية؟ يُرجى تضمين التغطية التي ستبدأ قريبًا.",
    "noDescription": "لا أحد لديه تغطية",
    "pleaseSpecify": "يرجى التحديد",
    "title": "حالات التغطية",
    "whatType": "ما نوع التغطية؟",
    "who": "من لديه تغطية؟",
    "yesDescription": "شخص ما لديه تغطية"
  },
  "applicationDateOfBirthScreen": {
    "description": "يرجى إضافة وتأكيد تواريخ الميلاد لجميع أفراد الأسرة",
    "success": "تم حفظ جميع تواريخ الميلاد",
    "title": "تاريخ الميلاد"
  },
  "applicationDocuments": {
    "description": "سنستخدم هذه المستندات لتأكيد التفاصيل في طلبك. يمكنك تحميل الملفات الآن أو العودة لاحقاً.",
    "title": "تحميل المستندات"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "إضافة مصروف آخر",
    "addExpense": "إضافة مصروف",
    "description": "أضف المصاريف الطبية والمبالغ القابلة للخصم لكل فرد من أفراد الأسرة.",
    "expenseTypes": {
      "ALIMONY_PAID": "النفقة المدفوعة",
      "CHILDCARE": "رعاية الأطفال",
      "IRA_CONTRIBUTIONS": "مساهمات التقاعد (IRA)",
      "MEDICAL_EXPENSES": "المصاريف الطبية",
      "MOVING_EXPENSES": "تكاليف الانتقال",
      "NONE": "لا يوجد",
      "OTHER": "أخرى",
      "STUDENT_LOANS": "قروض الطلاب",
      "TUITION_FEES": "الرسوم الدراسية"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "سنطلب منك تحميل ما يثبت هذه المصاريف لاحقاً، لذا يرجى تجهيز المستندات. قد تشمل الفواتير الطبية أو إيصالات الصيدليات.",
        "OTHER": "سنطلب منك تحميل ما يثبت هذه المصاريف لاحقاً.",
        "STUDENT_LOANS": "سنطلب منك تحميل ما يثبت هذه المصاريف لاحقاً. قد يشمل ذلك بيانات قروض الطلاب أو خطابات المنح المدرسية."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "هل لديك مصاريف طبية في الأشهر الثلاثة الماضية تحتاج مساعدة في دفعها؟",
      "title": "اختر نوع المصروف"
    },
    "monthlyExpense": "{{monthlyExpense}} / شهرياً",
    "progress": "التقدم: تم إكمال {{progress}} من {{total}}",
    "title": "مصاريف الأسرة"
  },
  "applicationFlow": {
    "amountPerMonth": "المبلغ شهرياً"
  },
  "applicationForm": {
    "applyingToCounter": "تقديم لـ {{programsCount}} برامج لـ {{householdMembersCount}} أفراد",
    "continueButton": "المتابعة إلى الطلبات",
    "greatNews": "أخبار رائعة!",
    "letsCreateApplications": "لنبدأ في إنشاء الطلبات للجميع.",
    "mayBeEligible": "قد يكون <bold>{{names}}</bold> مؤهلين",
    "mayBeEligibleFor": "قد يكون {{memberNames}} مؤهلين لـ <bold>{{brand}}</bold>",
    "notEligible": "غير مؤهل في الوقت الحالي",
    "programConflictDialog": {
      "description": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلب {{currentPrograms}} الخاص بـ {{memberNames}}. لا يمكن لـ {{memberNames}} التقديم على كليهما في الوقت نفسه. عند إرسال طلبك، سنتأكد من اختيار البرنامج المناسب لـ {{memberNames}}.",
      "description_members": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلبات {{currentPrograms}} الخاصة بـ {{memberNames}}. لا يمكن لـ {{memberNames}} التقديم على كليهما في الوقت نفسه. عند إرسال طلبك، سنتأكد من اختيار البرنامج المناسب لـ {{memberNames}}.",
      "description_self": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلبك الخاص بـ {{currentPrograms}}. لا يمكنك التقديم على كليهما في الوقت نفسه. عند إرسال طلبك، سنتأكد من أنك في البرنامج المناسب.",
      "keepButton": "الإبقاء على {{currentPrograms}}",
      "multipleDescription": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلبات {{currentPrograms}} الخاصة بـ {{memberNames}}. لا يمكن لـ {{memberNames}} التقديم عليها كلها في الوقت نفسه. عند إرسال طلبك، سنتأكد من اختيار البرنامج المناسب لـ {{memberNames}}.",
      "multipleDescription_members": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلبات {{currentPrograms}} الخاصة بـ {{memberNames}}. لا يمكن لـ {{memberNames}} التقديم عليها كلها في الوقت نفسه. عند إرسال طلبك، سنتأكد من اختيار البرامج المناسبة لـ {{memberNames}}.",
      "multipleDescription_self": "التقديم على {{newProgram}} سيؤدي إلى إزالة طلباتك الخاصة بـ {{currentPrograms}}. لا يمكنك التقديم عليها كلها في الوقت نفسه. عند إرسال طلبك، سنتأكد من أنك في البرنامج المناسب.",
      "recommendMedicaidDescription": "لا يمكن لـ {{memberNames}} التقديم على كليهما في الوقت نفسه. برنامج Medicaid مجاني و{{memberNames}} مؤهل له. عند إرسال طلبك، سنتأكد من اختيار البرنامج المناسب لـ {{memberNames}}.",
      "recommendMedicaidDescription_members": "لا يمكن لـ {{memberNames}} التقديم على كليهما في الوقت نفسه. برنامج Medicaid مجاني و{{memberNames}} مؤهلون له. عند إرسال طلبك، سنتأكد من اختيار البرامج المناسبة لـ {{memberNames}}.",
      "recommendMedicaidDescription_self": "لا يمكنك التقديم على كليهما في الوقت نفسه. برنامج Medicaid مجاني وأنت مؤهل له. عند إرسال طلبك، سنتأكد من أنك في البرنامج المناسب.",
      "recommendMedicaidTitle": "نوصي بالتقديم على Medicaid",
      "switchButton": "التبديل إلى {{newProgram}}",
      "title": "يمكنك التقديم على برنامج واحد فقط"
    },
    "programsFound": "وجدنا {{programsCount}} برامج مؤهلة لجميع أفراد الأسرة الـ {{householdMembersCount}}.",
    "recentDuplicateDialog": {
      "continueAnyway": "المتابعة على أي حال",
      "description": "لقد قدمت مؤخرًا طلبًا لبرنامج <bold>{{applicationType}}</bold> لصالح {{memberNames}}. ينبغي ألا تقدم طلبًا آخر إلا إذا طرأ تغيير.",
      "multipleDescription": "لقد قدمت مؤخرًا طلبات لبرامج <bold>{{applicationTypes}}</bold> لصالح {{memberNames}}. ينبغي ألا تقدم طلبًا آخر إلا إذا طرأ تغيير.",
      "title": "لقد قدمت طلبًا مؤخرًا"
    },
    "startButton": "بدء الطلبات"
  },
  "applicationMaritalStatusScreen": {
    "description": "لقد حددنا الحالة الاجتماعية بناءً على علاقات الأسرة. يرجى المراجعة والتحديث إذا لزم الأمر.",
    "needsMaritalStatus": "مطلوب الحالة الاجتماعية",
    "title": "الحالة الاجتماعية الحالية"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "من الهنود الأمريكيين أو سكان ألاسكا الأصليين",
      "needsHelpDailyActivities": "يحتاج مساعدة في الأنشطة اليومية",
      "studentFullTime18to20": "طالب بدوام كامل (عمره 18-20 سنة)",
      "veteranOrMilitaryMember": "محارب قديم أو عضو في الجيش"
    },
    "description": "يرجى اختيار أي حالات تنطبق على أفراد الأسرة.",
    "errors": {
      "unableToUpdateHouseholdMembers": "لم نتمكن من حفظ هذه التغييرات. يرجى المحاولة مرة أخرى."
    },
    "title": "حالات أخرى"
  },
  "applicationSection": {
    "applications": "الطلبات",
    "beginYourApplicationCompact": "قدّم في 15 دقيقة أو أقل",
    "beginYourApplicationProcess": "ابدأ عملية التقديم واحصل على التغطية في 15 دقيقة أو أقل",
    "continueQuickApply": "متابعة التقديم السريع",
    "continueYourApplicationCompact": "تابع طلبك",
    "continueYourApplicationProcess": "تابع عملية التقديم واحصل على التغطية في 15 دقيقة أو أقل",
    "newQuickApply": "تقديم سريع جديد",
    "quickApply": "تقديم سريع"
  },
  "applicationSubmitScreen": {
    "description": "لقد أكملت جميع الخطوات. عندما تكون جاهزًا، أرسل طلباتك أدناه.",
    "hintMessage": "لا يمكنك إجراء تغييرات بعد الإرسال، لذا يرجى التأكد من صحة كل شيء.",
    "partialFailure": "قد لا يكون قد تم إرسال بعض طلبات التغطية الخاصة بك. يرجى مراجعتها في قائمة الطلبات.",
    "submitButton": "إرسال الطلبات",
    "success": "تم إرسال الطلبات بنجاح.",
    "title": "لقد انتهيت!"
  },
  "applicationTaxInformationScreen": {
    "description": "بناءً على المعلومات التي شاركتها، نعتقد أن هذا يعكس الوضع الضريبي للجميع. يرجى المراجعة والتحديث.",
    "errors": {
      "unableToUpdateRelationship": "لم نتمكن من تحديث هذه العلاقة. يرجى المحاولة مرة أخرى."
    },
    "memberCard": {
      "dependentOf": "تابع لـ: {{name}}",
      "dependents": "التابعين لـ: {{name}}",
      "memberDialog": {
        "description": "راجع وحدّث التفاصيل الضريبية لهذا الشخص إذا لزم الأمر.",
        "saveAndReturn": "حفظ والعودة",
        "taxClaimedAsDependentStatus": "هل سيقوم أحد بالمطالبة بهذا الشخص كتابع ضريبي؟",
        "taxDependentsClaimedStatus": "هل سيطالب هذا الشخص بوجود تابعين له؟",
        "taxFilingStatus": "الوضع الضريبي",
        "title": "المعلومات الضريبية – {{name}}",
        "who": "من؟"
      }
    },
    "needsTaxInformation": "يحتاج معلومات الضرائب",
    "success": "تم تحديث المعلومات الضريبية بنجاح",
    "title": "المعلومات الضريبية"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "إضافة دخل آخر",
    "addIncome": "إضافة دخل",
    "description": "أضف معلومات العمل والدخل لكل فرد من أفراد الأسرة.",
    "incomeTypes": {
      "ALIMONY": "نفقة",
      "EMPLOYED": "موظف",
      "NONE": "لا يوجد",
      "OTHER": "أخرى",
      "PENSION": "راتب تقاعدي",
      "PROPERTY_RENTAL_INCOME": "دخل من إيجار عقار",
      "RETIREMENT_INCOME": "دخل تقاعدي",
      "SELF_EMPLOYED": "عمل حر",
      "SSA": "تأمينات اجتماعية (SSA)",
      "SSDI": "تأمين العجز (SSDI)",
      "UNEMPLOYED": "عاطل عن العمل",
      "WORKERS_COMPENSATION": "تعويضات العمال"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "سنطلب منك تحميل ما يثبت هذا الدخل لاحقاً. قد يشمل ذلك قسائم الراتب أو نماذج W-2.",
        "OTHER": "سنطلب منك تحميل ما يثبت هذا الدخل لاحقاً. قد يشمل ذلك خطابات المنح أو بيانات الفوائد.",
        "SELF_EMPLOYED": "سنطلب منك تحميل ما يثبت هذا الدخل لاحقاً. قد يشمل ذلك الفواتير أو نماذج 1099.",
        "UNEMPLOYED": "سنطلب منك تحميل ما يثبت هذا الدخل لاحقاً. قد يشمل ذلك خطابات منح تعويض البطالة."
      },
      "employerName": "اسم صاحب العمل",
      "enterName": "أدخل الاسم",
      "enterTypeOfWork": "أدخل نوع العمل",
      "grossMonthlyIncome": "إجمالي الدخل الشهري (قبل الضرائب)",
      "payFrequency": "تكرار الدفع",
      "selfEmploymentNetMonthlyIncome": "صافي الدخل الشهري المتوقع بعد المصاريف",
      "title": "اختر نوع الدخل",
      "typeOfWork": "نوع العمل",
      "unemploymentCompensationStatus": "هل تتلقى تعويض بطالة؟",
      "workWeekHours": "ساعات العمل في الأسبوع"
    },
    "monthlyIncome": "{{monthlyIncome}} / شهرياً",
    "title": "العمل والدخل"
  },
  "applicationsListScreen": {
    "applicationDate": "DD/MM/YYYY [الساعة] h:mm A",
    "inProgress": "قيد التنفيذ",
    "noApplications": "ليس لديك أي طلبات بعد.",
    "submitted": "تم الإرسال",
    "title": "طلبات {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "لم نتمكن من تسجيل دخولك باستخدام Apple. يرجى المحاولة مرة أخرى أو استخدام خيار آخر.",
    "checkYourEmail": "تحقق من بريدك الإلكتروني",
    "checkYourSpam": "لم تصلك الرسالة؟ تحقق من ملف البريد المزعج أو انتظر بضع دقائق.",
    "continueWithApple": "المتابعة باستخدام Apple",
    "continueWithGoogle": "المتابعة باستخدام Google",
    "dataSecured": "بياناتك في أمان معنا. متوافق مع معايير HIPAA وSOC 2.",
    "emailInput": "البريد الإلكتروني",
    "googleSignInFailed": "لم نتمكن من تسجيل دخولك باستخدام Google. يرجى المحاولة مرة أخرى أو استخدام خيار آخر.",
    "identifierInput": "البريد الإلكتروني أو اسم المستخدم",
    "invalidIdentifier": "أدخل بريدًا إلكترونيًا أو اسم مستخدم صالحًا.",
    "subtitle": "أدخل بريدك الإلكتروني أو اسم المستخدم للمتابعة.",
    "title": "تسجيل الدخول أو إنشاء حساب",
    "weSentALink": "أرسلنا رابطاً آمناً إلى <bold>{{email}}</bold>. اضغط على الرابط للمتابعة.",
    "youAgree": "بالمتابعة، فإنك توافق على <underline><colorEmphasis>شروط الخدمة</colorEmphasis></underline> و <privacyLink><colorEmphasis>سياسة الخصوصية</colorEmphasis></privacyLink>."
  },
  "brokerConsent": {
    "noButton": "لا شكراً",
    "recommendedBadge": "موصى به",
    "yesButton": "نعم، قم بتوصيلي"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "المتابعة مع Medicaid فقط",
    "continueWithoutAgentButton": "المتابعة بدون وكيل",
    "declineCard": {
      "applyLink": "التقديم على {{program}}",
      "fallbackWithMedicaid": "لا يزال بإمكانك متابعة طلب Medicaid الخاص بك هنا. يمكن لـ Pointcare التعامل مع طلب Medicaid الخاص بك بدون وكيل.",
      "fallbackWithoutMedicaid": "لا يزال بإمكانك متابعة طلبك هنا. إتمامه الآن يعني أن Pointcare ستتمكن من دعمك عندما تتغير احتياجاتك التأمينية.",
      "selfEnrollmentWarning": "بدون وكيل، ستحتاج إلى التسجيل في {{programs}} بنفسك.",
      "title": "اختر «نعم، قم بتوصيلي» للاستفادة القصوى من Pointcare"
    },
    "subtitle": "سنوصلك بالوكيل عندما يحين وقت التسجيل، ولن نشارك سوى ما هو ضروري للمساعدة.",
    "subtitleWithIndividual": "سنوصلك بالوكيل عندما يحين وقت التسجيل، ولن نشارك سوى ما هو ضروري للمساعدة. إذا كنت تتقدم بطلب للحصول على Medicare، فسيكون هذا الوكيل {{brokerName}}.",
    "subtitleWithIndividualLicense": "سنوصلك بالوكيل عندما يحين وقت التسجيل، ولن نشارك سوى ما هو ضروري للمساعدة. إذا كنت تتقدم بطلب للحصول على Medicare، فسيكون هذا الوكيل {{brokerName}} (رقم الرخصة: {{licenseNumber}}).",
    "subtitleWithOrganization": "سنوصلك بالوكيل عندما يحين وقت التسجيل، ولن نشارك سوى ما هو ضروري للمساعدة. إذا كنت تتقدم بطلب للحصول على Medicare، فسيكون هذا الوكيل من {{brokerName}}.",
    "subtitleWithOrganizationLicense": "سنوصلك بالوكيل عندما يحين وقت التسجيل، ولن نشارك سوى ما هو ضروري للمساعدة. إذا كنت تتقدم بطلب للحصول على Medicare، فسيكون هذا الوكيل من {{brokerName}} (رقم الرخصة: {{licenseNumber}}).",
    "title": "تواصل مع وكيل تأمين مرخص لاستكشاف خيارات Medicare و/أو سوق قانون الرعاية ميسورة التكلفة (ACA) والحصول على المساعدة في إتمام التسجيل"
  },
  "camera": {
    "grantPermission": "منح الإذن",
    "permissionDescription": "لتصوير مستنداتك، يرجى السماح بالوصول إلى الكاميرا في إعدادات هاتفك.",
    "permissionRequired": "نحتاج إلى الوصول إلى الكاميرا الخاصة بك.",
    "photoCount": "تم التقاط {{count}} صورة",
    "tapToCapture": "اضغط على الزر لالتقاط صورة"
  },
  "cesSurvey": {
    "feedbackLabel": "ما الذي جعل هذا صعباً؟",
    "feedbackPlaceholder": "أخبرنا المزيد",
    "optionalLabel": "اختياري",
    "questions": {
      "consentFormSigned": "ما مدى سهولة فهم ما كنت توقّع عليه؟",
      "householdMemberAdded": "ما مدى سهولة إضافة أحد أفراد الأسرة؟",
      "incomeAdded": "ما مدى سهولة إضافة الدخل؟"
    },
    "scoreEasy": "سهل",
    "scoreHard": "صعب",
    "scoreOk": "مقبول",
    "scoreVeryEasy": "سهل جداً",
    "scoreVeryHard": "صعب جداً",
    "thanksDescription": "ملاحظاتك تساعدنا على التحسين.",
    "thanksTitle": "شكراً!"
  },
  "consentDocuments": {
    "addSignature": "إضافة توقيع",
    "description": "وقّع أدناه حتى نتمكن من دعمك.",
    "documentTitle": "تفويض بالإصدار (PDF)",
    "grant1": "مراقبة تغطيتك وحل المشكلات مبكراً",
    "grant2": "الرد على الطلبات نيابة عنك - لا ضياع للرسائل أو تعب",
    "grant3": "تقديم الطلبات والتجديدات والمتابعة لضمان عدم تفويت المواعيد النهائية",
    "grant4": "التواصل معك لأغراض تسويقية عبر المكالمات الهاتفية العادية أو الآلية، والرسائل الصوتية، والرسائل النصية",
    "grantHealthPlanSelection": "تطبيق اختيارك لخطة الرعاية الصحية والطبيب (عند توفره) على تغطيتك",
    "grantSubtitle": "إليك ما يتضمنه ذلك:",
    "healthPlanAvailabilityError": "تعذّر علينا التحقق من خطط الرعاية الصحية المتاحة. يُرجى المحاولة مرة أخرى قبل التوقيع.",
    "signatureCountsAsInitials": "يُعتبر توقيعك أيضًا بمثابة الأحرف الأولى من اسمك في النموذج حيثما ينطبق ذلك.",
    "title": "إدارة تغطية عائلتك",
    "viewDocument": "عرض المستند"
  },
  "coverage": {
    "code": "الرمز:",
    "coverageStatus": "حالة التغطية",
    "inProgress": "قيد التنفيذ",
    "isCovered": "{{name}} مغطى بواسطة {{programs}}.",
    "lastCheck": "آخر فحص",
    "lastCheckDateFormat": "DD/MM/YYYY",
    "lastCheckWithDate": "آخر فحص {{date}}",
    "noMatchingRecord": "لم نتمكن من العثور على التغطية الخاصة بك. يرجى التأكد من البيانات والمحاولة مرة أخرى.",
    "planName": "اسم الخطة",
    "primaryCareProvider": "مقدم الرعاية الأولية",
    "programCoverage": "تغطية {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> و <bold>Medicaid</bold>"
    },
    "serviceTypes": "أنواع الخدمات",
    "status": {
      "checking": "جاري التحقق من التغطية...",
      "checkingShort": "جاري التحقق...",
      "covered": "مغطى",
      "coveredBy": "مغطى بواسطة {{ programs }}",
      "notCovered": "غير مغطى",
      "unknown": "التغطية غير معروفة",
      "unknownShort": "غير معروف"
    },
    "updateProfileInformation": "تحديث معلومات الملف الشخصي"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "كلمة المرور",
    "passwordInputPlaceholder": "أنشئ كلمة مرور",
    "passwordRequirement": "استخدم 10 أحرف على الأقل.",
    "subtitle": "قم بتأمين حسابك الجديد بكلمة مرور قوية للمتابعة.",
    "title": "إنشاء كلمة مرور"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "كلمة المرور",
    "passwordInputPlaceholder": "أنشئ كلمة مرور",
    "subtitle": "قم بتأمين حسابك الجديد بكلمة مرور قوية للمتابعة.",
    "title": "إنشاء كلمة مرور"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "يوم",
    "monthPlaceholder": "شهر",
    "yearPlaceholder": "سنة"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "استخدم إجمالي الدخل (قبل الضرائب). إذا كنت تعمل لحسابك الخاص، استخدم صافي دخلك (بعد مصاريف العمل).",
    "description2": "يشمل ذلك الدخل التقديري لجميع أفراد الأسرة:",
    "hideBreakdown": "إخفاء التفاصيل",
    "householdIncomeCalculator": {
      "annualDescription": "أدخل الدخل السنوي التقديري لكل شخص لحساب المجموع",
      "biWeeklyDescription": "أدخل الدخل التقديري كل أسبوعين لكل شخص لحساب المجموع",
      "monthlyDescription": "أدخل الدخل الشهري التقديري لكل شخص لحساب المجموع",
      "period": {
        "annual": "سنة",
        "biWeekly": "أسبوعين",
        "monthly": "شهر"
      },
      "title": "احسب دخلك",
      "totalIncomeTitle": "إجمالي دخل الأسرة:",
      "totalIncomeValue": "{{total}} / {{period}}",
      "useRange": "استخدم {{label}}"
    },
    "incomePeriod": {
      "annual": "سنوي",
      "biWeekly": "كل أسبوعين",
      "monthly": "شهري"
    },
    "incomeRange": {
      "0-1800": "$0 - $1,800",
      "0-3700": "$0 - $3,700",
      "0-44400": "$0 - $44,400",
      "1600-2600": "$1,600 - $2,600",
      "2500-3000": "$2,500 - $3,000",
      "3000-3300": "$3,000 - $3,300",
      "3300+": "$3,300 أو أكثر",
      "3500-5600": "$3,500 - $5,600",
      "43000-67000": "$43,000 - $67,000",
      "5500-6500": "$5,500 - $6,500",
      "6500-7000": "$6,500 - $7,000",
      "66000-78000": "$66,000 - $78,000",
      "7000+": "$7,000 أو أكثر",
      "78000-83000": "$78,000 - $83,000",
      "83000+": "$83,000 أو أكثر"
    },
    "showBreakdown": "تحتاج مساعدة في الحساب؟ أظهر التفاصيل",
    "title": "ما هو دخل أسرتك التقريبي؟",
    "updateError": "لم نتمكن من حفظ دخلك. يرجى المحاولة مرة أخرى."
  },
  "eligibilityHouseholdMembers": {
    "title": "أسرتك",
    "you": "أنت"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "يجب أن <bold>يعيشوا معك</bold> لأكثر من <bold>نصف العام</bold>، ويجب أن <bold>توفر أكثر من نصف</bold> نفقاتهم السنوية (الغذاء، السكن، الدراسة، والفواتير الطبية).",
    "formDescription": "أضف أي أطفال أو أحفاد أو أطفال تحت الرعاية دون سن 19 يعيشون معك وتدعمهم مالياً.",
    "formTitle": "أخبرنا عن الأطفال الذين تعيلهم",
    "supporterDescription": "يجب أن <bold>يعيشوا مع {{supporterFirstName}}</bold> لأكثر من <bold>نصف العام</bold>، ويجب أن <bold>يوفر {{supporterFirstName}} أكثر من نصف</bold> نفقاتهم السنوية.",
    "supporterFormDescription": "أضف أي أطفال يعيشون مع {{supporterFirstName}}.",
    "supporterFormTitle": "أخبرنا عن أطفال {{supporterFirstName}}",
    "supporterTitle": "هل يعيش {{supporterFirstName}} مع أطفال دون سن 19 ويرعاهم؟",
    "title": "هل تعيش مع أطفال دون سن 19 وترعاهم؟"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "هذا يساعدنا في فهم وضع أسرتك وتحديد البرامج التي قد تكون مؤهلاً لها.",
    "formDescription": "نحتاج لبعض المعلومات الأساسية عن الزوج(ة) أو الشريك للمساعدة في تحديد أهليتك.",
    "formTitle": "أخبرنا عن الزوج(ة) أو الشريك",
    "supporterFormDescription": "نحتاج معلومات أساسية عن زوج(ة) أو شريك {{supporterFirstName}}.",
    "supporterFormTitle": "أخبرنا عن زوج(ة) أو شريك {{supporterFirstName}}",
    "supporterTitle": "ما هي الحالة الاجتماعية لـ {{supporterFirstName}}؟",
    "title": "ما هي حالتك الاجتماعية؟"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "يجب أن <bold>توفر أكثر من نصف</bold> نفقاتهم السنوية (الغذاء، السكن، الدراسة، والفواتير الطبية).",
    "formDescription": "أضف أي طلاب بدوام كامل تتراوح أعمارهم بين 18-21 عاماً وتكون أنت والدهم أو وصيهم القانوني وتعيلهم مالياً.",
    "formTitle": "أخبرنا عن الطالب الذي تعيله",
    "supporterDescription": "يجب أن يوفر {{supporterFirstName}} <bold>أكثر من نصف</bold> نفقاتهم السنوية.",
    "supporterFormDescription": "أضف أي طلاب بدوام كامل (18-21 عاماً) يعيلهم {{supporterFirstName}}.",
    "supporterFormTitle": "أخبرنا عن الطالب الذي يعيله {{supporterFirstName}}",
    "supporterTitle": "هل {{supporterFirstName}} والد أو وصي لطالب بدوام كامل (18-21 عاماً) ويعيله مالياً؟",
    "title": "هل أنت والد أو وصي قانوني لطالب بدوام كامل (18-21 عاماً) وتعيله مالياً؟"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "يشمل ذلك الغذاء، السكن، الدراسة، والفواتير الطبية.",
    "errors": {
      "updateFailed": "لم نتمكن من حفظ هذه التغييرات. يرجى المحاولة مرة أخرى."
    },
    "formDescription": "أضف الشخص الذي يوفر أكثر من نصف دعمك المالي السنوي، مثل الوالدين أو الوصي.",
    "formTitle": "أخبرنا عن الشخص الذي يعيلك",
    "options": {
      "disabled": "نعم، أنا من ذوي الاحتياجات الخاصة وأعيش طوال العام مع الشخص الذي يعيلني.",
      "fullTimeStudent": "نعم، أنا طالب بدوام كامل ويعيلني والدي أو وصي القانوني.",
      "personSupportsMe": "نعم، أعيش أكثر من نصف العام مع الشخص الذي يعيلني.",
      "relativeSupportsMe": "نعم، أعيش أكثر من نصف العام مع قريب يعيلني."
    },
    "title": "هل يوفر شخص ما أكثر من نصف دعمك المالي السنوي؟"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "إضافة تفاصيل",
    "conditions": {
      "blind": "شخص ما كفيف",
      "breastCancer": "شخص ما مصاب بسرطان الثدي",
      "cervicalCancer": "شخص ما مصاب بسرطان عنق الرحم",
      "disabled": "شخص ما من ذوي الاحتياجات الخاصة (SSDI)",
      "fosterCare": "كان شخص ما في نظام رعاية الأيتام عند بلوغه 18 عاماً",
      "pregnant": "يوجد حمل"
    },
    "description": "يرجى اختيار أي حالات تنطبق على أفراد الأسرة.",
    "errors": {
      "allUpdatesFailed": "لم نتمكن من حفظ هذه التغييرات. يرجى المحاولة مرة أخرى."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "تاريخ الولادة المتوقع",
      "numberOfBabies": "عدد المواليد المتوقع",
      "title": "تفاصيل الحمل"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "طفل واحد • موعد الولادة {{date}}",
      "babiesWithCount_other": "{{count}} أطفال • موعد الولادة {{date}}"
    },
    "title": "حالات خاصة في أسرتك"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "يمكن أن يكون أي شخص — طفل، أخ، جد، أو قريب غير بيولوجي — من أي عمر. يجب أن <bold>توفر أكثر من نصف</bold> نفقاتهم السنوية.",
    "formDescription": "أضف أي أشخاص من ذوي الاحتياجات الخاصة يعيشون معك طوال العام وتعيلهم مالياً.",
    "formTitle": "أخبرنا عن الشخص الذي تعيله",
    "supporterDescription": "يمكن أن يكون أي شخص. يجب أن يوفر {{supporterFirstName}} <bold>أكثر من نصف</bold> نفقاتهم السنوية.",
    "supporterFormDescription": "أضف أي أشخاص من ذوي الاحتياجات الخاصة يعيلهم {{supporterFirstName}}.",
    "supporterFormTitle": "أخبرنا عن الشخص الذي يعيله {{supporterFirstName}}",
    "supporterTitle": "هل يعيل {{supporterFirstName}} مالياً شخصاً من ذوي الاحتياجات الخاصة يعيش معه طوال العام؟",
    "title": "هل تعيل مالياً شخصاً من ذوي الاحتياجات الخاصة يعيش معك طوال العام؟"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "يجب أن <bold>يعيشوا معك</bold> لأكثر من <bold>نصف العام</bold> وتوفر لهم <bold>أكثر من نصف</bold> نفقاتهم. يشمل ذلك الأقارب المباشرين وغير المباشرين.",
    "formDescription": "أضف أي أقارب يعيشون معك وتعيلهم مالياً.",
    "formTitle": "أخبرنا عن الأقارب الذين تعيلهم",
    "supporterDescription": "يجب أن <bold>يعيشوا مع {{supporterFirstName}}</bold> لأكثر من نصف العام.",
    "supporterFormDescription": "أضف أي أقارب يعيلهم {{supporterFirstName}}.",
    "supporterFormTitle": "أخبرنا عن الأقارب الذين يعيلهم {{supporterFirstName}}",
    "supporterTitle": "هل يعيل {{supporterFirstName}} مالياً أي أقارب آخرين يعيشون معه؟",
    "title": "هل تعيل مالياً أي أقارب آخرين يعيشون معك؟"
  },
  "homeScreen": {
    "addMember": "إضافة فرد",
    "applicationSubmittedCard_multiple": "لقد قدمت طلبات <programs /> لصالح {{memberNames}}. سنراجعها ونتواصل معك إذا احتجنا إلى أي شيء.",
    "applicationSubmittedCard_single": "لقد قدمت طلب <programs /> لصالح {{memberNames}}. سنراجعه ونتواصل معك إذا احتجنا إلى أي شيء.",
    "applicationSubmittedCard_singleMarketplace": "لقد قدمت طلب <programs /> لصالح {{memberNames}}. سنراجعه ونتواصل معك إذا احتجنا إلى أي شيء.",
    "checkEligibility": "التحقق من أهلية الأسرة",
    "checkEligibilityCompact": "التحقق من الأهلية",
    "devScenarioActive": "سيناريو محاكاة نشط — تعرض لوحة المعلومات بيانات تجريبية.",
    "devScenarioReset": "إعادة تعيين",
    "eligibilityCardCompactNotStarted": "اعرف البرامج التي قد تتأهل لها",
    "eligibilityCardCompactStarted": "تابع لمعرفة البرامج التي قد تتأهل لها",
    "eligibilityCardNotStarted": "ابدأ فحصاً سريعاً خطوة بخطوة لمعرفة البرامج التي قد تتأهل لها أسرتك",
    "eligibilityCardStarted": "تابع فحص الأهلية لمعرفة البرامج التي قد تتأهل لها أسرتك",
    "household": "الأسرة",
    "logout": "تسجيل الخروج",
    "nextSteps": "الخطوات التالية",
    "recheckEligibility": "إعادة فحص الأهلية"
  },
  "householdMemberScreen": {
    "applicantDocuments": "مستندات المتقدم",
    "checkCoverage": "التحقق من التغطية",
    "deleteButton": "إزالة {{memberFullName}} من الأسرة",
    "deleteDialog": {
      "description": "سيؤدي هذا إلى حذف {{memberFullName}} نهائياً من أسرتك. سيتم حذف جميع معلوماتهم ومستنداتهم ولا يمكن استعادتها.",
      "title": "إزالة فرد من الأسرة"
    },
    "deleteToast": {
      "error": "لم نتمكن من إزالة هذا الفرد من الأسرة. يرجى المحاولة مرة أخرى.",
      "success": "تم حذف فرد الأسرة بنجاح"
    },
    "profileInformation": "معلومات الملف الشخصي"
  },
  "landingScreen": {
    "goToAuth": "الانتقال لشاشة تسجيل الدخول"
  },
  "languageSelectorModal": {
    "title": "اختر اللغة"
  },
  "languages": {
    "arabicDescription": "العربية",
    "chineseSimplifiedDescription": "الصينية المبسطة",
    "englishDescription": "الإنجليزية",
    "haitianCreoleDescription": "الكريولية الهايتية",
    "russianDescription": "الروسية",
    "spanishDescription": "الإسبانية",
    "tagalogDescription": "التاغالوغية",
    "vietnameseDescription": "الفيتنامية"
  },
  "memberFormSubmission": {
    "error": "لم نتمكن من حفظ هذه التغييرات. يرجى المحاولة مرة أخرى.",
    "success": "تم تحديث بيانات فرد الأسرة بنجاح"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "رقم الهاتف",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "سنرسل لك رمز تحقق.",
    "subtitle": "سنستخدم هذا للحفاظ على أمان حسابك.",
    "title": "ما هو رقم هاتفك؟"
  },
  "mfaVerifyScreen": {
    "getNewCode": "الحصول على رمز جديد",
    "subtitle": "يرجى إدخال الرمز المكون من 6 أرقام الذي أرسلناه إلى\n<bold>{{phoneNumber}}</bold>",
    "title": "أرسلنا لك رمزاً",
    "verificationCodeLabel": "رمز التحقق"
  },
  "notFound": {
    "cta": "العودة للرئيسية",
    "description": "الصفحة التي تبحث عنها لم تعد موجودة.",
    "title": "لم يتم العثور على الصفحة."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "ما أكثر ما أعجبك في Pointcare؟ (اختياري)",
    "highFeedbackPlaceholder": "أخبرنا بما لفت انتباهك",
    "lowFeedbackLabel": "ما الذي يمكننا تحسينه؟ (اختياري)",
    "lowFeedbackPlaceholder": "أخبرنا بما لم يكن جيداً...",
    "mediumFeedbackLabel": "ما الذي كان سيجعل هذا يستحق 10 بالنسبة لك؟ (اختياري)",
    "mediumFeedbackPlaceholder": "ما الذي كان سيجعله أفضل...",
    "scaleHighLabel": "→ محتمل جداً",
    "scaleLowLabel": "→ غير محتمل إطلاقاً",
    "submitButton": "إرسال الملاحظات",
    "subtitle": "لا تتم مشاركة إجاباتك أبداً مع البرامج التي تقدمت إليها.",
    "success": "تم إرسال الملاحظات بنجاح.",
    "testimonialLabel": "هل يمكننا مشاركة ملاحظاتك على موقعنا الإلكتروني لمساعدة المزيد من الأشخاص في العثور على تغطية؟ سنستخدم اسمك الأول فقط.",
    "title": "ما مدى احتمالية أن توصي بـ Pointcare لصديق أو فرد من العائلة؟"
  },
  "onboarding": {
    "benefits": {
      "description": "تساعد Pointcare أكثر من 1.8 مليون مريض في جميع أنحاء الولايات المتحدة في العثور على تغطيتهم الصحية والحفاظ عليها.",
      "firstItem": "اكتشف من يتأهل خلال 5 دقائق",
      "firstItem_AGING_INTO_MEDICARE": "اعثر على تغطية Medicare المناسبة",
      "firstItem_AGING_INTO_MEDICARE_awareness": "ابقَ على اطلاع بالمواعيد النهائية",
      "firstItem_LAPSE": "اكتشف من يتأهل خلال 5 دقائق",
      "firstItem_QR_CODE": "اكتشف من يتأهل خلال 5 دقائق",
      "firstItem_RECURRING_WORK_REQUIREMENT": "لا تفوت أبداً أي موعد نهائي مهم",
      "firstItem_REDETERMINATION": "لا تفوت أبداً أي موعد نهائي مهم",
      "firstItem_SELF_PAY_CONVERSION": "اكتشف من يتأهل خلال 5 دقائق",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "لا تفوت أبداً أي موعد نهائي مهم",
      "firstItem_SERVICE_INTRODUCTION_medicare": "تحقق من مزايا الجميع في 5 دقائق",
      "freeToUse": "مساعدة مجانية - بدون رسوم خفية",
      "infoIsPrivate": "أي معلومات تشاركها تبقى خاصة",
      "title": "لقد عقدت {{clinicName}} شراكة مع Pointcare لدعم عائلتك",
      "titleNoClinic": "‏بوينت كير هنا لدعم عائلتكم"
    },
    "buttons": {
      "createMyProfile": "إنشاء ملفي الشخصي",
      "getStarted": "ابدأ الآن"
    },
    "concerns": {
      "description": "اختر الخيار الأكثر أهمية بالنسبة لك — وسنوضح لك كيف يمكننا المساعدة.",
      "description_SERVICE_INTRODUCTION_medicare": "اختر الخيار الذي يصف هذه التغطية بشكل أفضل.",
      "title": "ما هو أكثر شيء يزعجك بشأن الحصول على تغطية لعائلتك؟",
      "title_SERVICE_INTRODUCTION_medicare": "ما هي تغطية Medicare المتوفرة لدى عائلتك؟"
    },
    "figuringOutWhenToRenew": {
      "option": "معرفة موعد التجديد",
      "subtext": "سنقوم بتتبع تواريخ التجديد للجميع وتذكيرك قبل فوات الأوان."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "معرفة موعد تقديم المتطلبات",
      "subtext": "سنتابع تواريخ متطلبات العمل ونذكرك في الوقت المناسب."
    },
    "imNotSure": {
      "option": "لست متأكداً",
      "subtext": "سنتأكد من أن خطة الجميع لا تزال مناسبة لهم."
    },
    "intro": {
      "description": "الكثير من الناس لا يدفعون شيئاً. والبعض يدفع مبالغ بسيطة مثل 20-30 دولاراً شهرياً. سنطرح بضعة أسئلة بسيطة لنجد أفضل خيار للجميع.",
      "description_AGING_INTO_MEDICARE": "ربما تصلك الكثير من العروض الآن. بصفتنا مقدم الرعاية الصحية لعائلتك، سنساعدك في العثور على الخطة المناسبة.",
      "description_AGING_INTO_MEDICARE_awareness": "ربما تصلك الكثير من العروض الآن. بصفتنا مقدم الرعاية الصحية لعائلتك، سنساعدك في العثور على الخطة المناسبة.",
      "description_LAPSE": "7 من كل 10 أشخاص قد يتأهلون مجدداً لتغطية مجانية أو منخفضة التكلفة. سواء كان ذلك إعادة التسجيل في Medicaid أو إيجاد خيار آخر، سنساعدك في كل خطوة.",
      "description_QR_CODE": "الكثير من الناس لا يدفعون شيئاً. والبعض يدفع مبالغ بسيطة. سنطرح بضعة أسئلة بسيطة لنجد أفضل خيار للجميع.",
      "description_RECURRING_WORK_REQUIREMENT": "يتطلب قانون جديد إثبات الدخل. سنتحقق مما إذا كان المتأثرون على المسار الصحيح أو معفيين من هذه المتطلبات وسندعمك من هناك.",
      "description_REDETERMINATION": "ستحتاج إلى تأكيد أو تحديث معلومات أسرتك للحفاظ على تغطيتهم. سنساعدك في كل خطوة على الطريق.",
      "description_SELF_PAY_CONVERSION": "الكثير من الناس لا يدفعون شيئاً. سنطرح بضعة أسئلة بسيطة لنجد أفضل خيار للجميع.",
      "description_SERVICE_INTRODUCTION_medicaid": "سنراقب تغطية الجميع، ونساعد في التجديدات، ونرشدك خلال أي شيء يطرأ - مجاناً.",
      "description_SERVICE_INTRODUCTION_medicare": "سنساعدك في فهم تغطية الجميع، والعثور على مزايا إضافية، والتأكد من عدم تفويت أي شيء.",
      "title": "الحصول على تغطية صحية ليس أمراً صعباً. قد تتأهل عائلتك لـ <colorEmphasis>خطط مجانية أو منخفضة التكلفة</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "يبدو أن شخصاً ما في عائلتك مؤهل لـ Medicare منذ <colorEmphasis>{{count}} شهر</colorEmphasis>. نحن هنا للمساعدة.",
      "title_AGING_INTO_MEDICARE_awareness_one": "يبدو أن شخصاً ما في عائلتك سيكون مؤهلاً لـ Medicare <colorEmphasis>خلال شهر واحد</colorEmphasis>. نحن هنا للمساعدة.",
      "title_AGING_INTO_MEDICARE_awareness_other": "يبدو أن شخصاً ما في عائلتك سيكون مؤهلاً لـ Medicare <colorEmphasis>خلال {{monthsToTurning65}} أشهر</colorEmphasis>. نحن هنا للمساعدة.",
      "title_AGING_INTO_MEDICARE_one": "يبدو أن شخصاً ما في عائلتك مؤهل لـ Medicare منذ <colorEmphasis>شهر واحد</colorEmphasis>. نحن هنا للمساعدة.",
      "title_AGING_INTO_MEDICARE_other": "يبدو أن شخصاً ما في عائلتك مؤهل لـ Medicare منذ <colorEmphasis>{{count}} شهر</colorEmphasis>. نحن هنا للمساعدة.",
      "title_AGING_INTO_MEDICARE_zero": "يبدو أن شخصاً ما في عائلتك أصبح مؤهلاً لـ Medicare <colorEmphasis>ابتداءً من هذا الشهر</colorEmphasis>. نحن هنا للمساعدة.",
      "title_LAPSE": "يبدو أن شخصاً ما في عائلتك فقد تغطية {{payerName}} في <colorEmphasis>{{lapseDate}}</colorEmphasis>. نحن هنا لمساعدتهم على استعادة التغطية.",
      "title_QR_CODE": "قد تتأهل عائلتك لـ <colorEmphasis>تغطية صحية مجانية أو منخفضة التكلفة</colorEmphasis>. دعنا نكتشف ذلك.",
      "title_RECURRING_WORK_REQUIREMENT_one": "يبدو أن لدى شخص ما في عائلتك متطلبات عمل لـ {{payerName}} تستحق <colorEmphasis>خلال شهر واحد</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_RECURRING_WORK_REQUIREMENT_other": "يبدو أن لدى شخص ما في عائلتك متطلبات عمل لـ {{payerName}} تستحق <colorEmphasis>خلال {{count}} أشهر</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "يبدو أن لدى شخص ما في عائلتك متطلبات عمل لـ {{payerName}} تستحق <colorEmphasis>هذا الشهر</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_REDETERMINATION_one": "يبدو أن لدى شخص ما في عائلتك تجديد لـ {{payerName}} يستحق <colorEmphasis>خلال شهر واحد</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_REDETERMINATION_other": "يبدو أن لدى شخص ما في عائلتك تجديد لـ {{payerName}} يستحق <colorEmphasis>خلال {{count}} أشهر</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_REDETERMINATION_zero": "يبدو أن لدى شخص ما في عائلتك تجديد لـ {{payerName}} يستحق <colorEmphasis>هذا الشهر</colorEmphasis>. لنحافظ على تغطيتهم.",
      "title_SERVICE_INTRODUCTION_medicaid": "نحن هنا لمساعدة عائلتك في <colorEmphasis>البقاء تحت تغطية {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "هل تحصل عائلتك على <colorEmphasis>أقصى استفادة من {{payerName}}؟</colorEmphasis> نحن هنا للمساعدة."
    },
    "keepingMyCurrentDoctors": {
      "option": "الاحتفاظ بأطبائي الحاليين",
      "subtext": "سنساعدك في العثور على خطة تشمل الأطباء الذين تزورهم عائلتك بالفعل."
    },
    "meetingRequirements": {
      "option": "تلبية المتطلبات",
      "subtext": "سندعم الجميع عندما يتعلق الأمر بتلبية وتقديم متطلبات العمل."
    },
    "missingEnrolmentDeadline": {
      "option": "تجاوز مواعيد التسجيل النهائية",
      "subtext": "سنتأكد من معرفتك بموعد التسجيل لتجنب أي غرامات تأخير."
    },
    "nextSteps": {
      "step1Description": "أخبرنا عن نفسك",
      "step1Duration": "دقيقتان",
      "step1Title": "إنشاء الملف الشخصي",
      "step2Description": "التغطية التي تستحقها عائلتك",
      "step2Description_AGING_INTO_MEDICARE": "مراجعة الحالة الحالية",
      "step2Description_AGING_INTO_MEDICARE_awareness": "مراجعة الحالة الحالية",
      "step2Description_LAPSE": "التغطية التي تستحقها عائلتك",
      "step2Description_QR_CODE": "التغطية التي تستحقها عائلتك",
      "step2Description_RECURRING_WORK_REQUIREMENT": "سنتحقق مما إذا كان المتأثرون معفيين أو على المسار الصحيح",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "سنتحقق مما إذا كان المتأثرون معفيين أو على المسار الصحيح",
      "step2Description_REDETERMINATION": "سيتواصل معك فريق الاتصال لدينا",
      "step2Description_REDETERMINATION_awareness": "بما في ذلك معلومات الاتصال الأساسية",
      "step2Description_SELF_PAY_CONVERSION": "التغطية التي تستحقها عائلتك",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "مراجعة الحالة الحالية",
      "step2Description_SERVICE_INTRODUCTION_medicare": "مراجعة الحالة الحالية",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "مراجعة الحالة الحالية",
      "step2Duration": "5 دقائق",
      "step2Duration_AGING_INTO_MEDICARE": "دقيقتان",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "دقيقتان",
      "step2Duration_LAPSE": "5 دقائق",
      "step2Duration_QR_CODE": "5 دقائق",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 دقائق",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 دقائق",
      "step2Duration_REDETERMINATION": "دقيقتان",
      "step2Duration_SELF_PAY_CONVERSION": "5 دقائق",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "دقيقتان",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "دقيقتان",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "دقيقتان",
      "step2Title": "اعثر على خياراتك",
      "step2Title_AGING_INTO_MEDICARE": "تحقق من التغطية",
      "step2Title_AGING_INTO_MEDICARE_awareness": "تحقق من التغطية",
      "step2Title_LAPSE": "اعثر على خياراتك",
      "step2Title_QR_CODE": "اعثر على خياراتك",
      "step2Title_RECURRING_WORK_REQUIREMENT": "التحقق من المتطلبات",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "التحقق من المتطلبات",
      "step2Title_REDETERMINATION": "طلب دعم التجديد",
      "step2Title_REDETERMINATION_awareness": "إضافة معلومات الأسرة",
      "step2Title_SELF_PAY_CONVERSION": "اعثر على خياراتك",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "تحقق من التغطية",
      "step2Title_SERVICE_INTRODUCTION_medicare": "تحقق من التغطية",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "تحقق من التغطية",
      "step3Description": "سنتولى نحن الباقي!",
      "step3Description_AGING_INTO_MEDICARE": "سنتولى نحن الباقي!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "سنبقيك على اطلاع ومستعداً",
      "step3Description_LAPSE": "سنتولى نحن الباقي!",
      "step3Description_QR_CODE": "سنتولى نحن الباقي!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "سنرشدك خلال هذا الأمر",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "سنبقيك على اطلاع وندعم عائلتك لتلبية المتطلبات",
      "step3Description_REDETERMINATION": "سنرشدك خلال هذا الأمر",
      "step3Description_REDETERMINATION_awareness": "سنبقيك على اطلاع ومستعداً",
      "step3Description_SELF_PAY_CONVERSION": "سنتولى نحن الباقي!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "سنقوم بتنبيهك مسبقاً",
      "step3Description_SERVICE_INTRODUCTION_medicare": "تعرف على ما تتضمنه خطة الجميع",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "توسيع المزايا",
      "step3Duration": "15 دقيقة",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "دقيقة واحدة",
      "step3Title": "إرسال الطلب",
      "step3Title_AGING_INTO_MEDICARE": "التقديم لـ Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "جاهز لـ Medicare",
      "step3Title_LAPSE": "إرسال الطلب",
      "step3Title_QR_CODE": "إرسال الطلب",
      "step3Title_RECURRING_WORK_REQUIREMENT": "إرسال المتطلبات",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "كن سباقاً في المتطلبات",
      "step3Title_REDETERMINATION": "إرسال التجديد",
      "step3Title_REDETERMINATION_awareness": "كن سباقاً في التجديد",
      "step3Title_SELF_PAY_CONVERSION": "إرسال الطلب",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "لا تفوت أي موعد نهائي",
      "step3Title_SERVICE_INTRODUCTION_medicare": "مراجعة مزاياك",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "استكشاف خيارات Medicare",
      "title": "جاهز لتأمين التغطية لعائلتك؟",
      "title_RECURRING_WORK_REQUIREMENT": "لنحافظ على تغطية عائلتك",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "لنحافظ على تغطية عائلتك",
      "title_REDETERMINATION": "لنحافظ على تغطية عائلتك",
      "title_REDETERMINATION_awareness": "لنحافظ على تغطية عائلتك",
      "title_SERVICE_INTRODUCTION_medicaid": "لنحافظ على تغطية عائلتك",
      "title_SERVICE_INTRODUCTION_medicare": "لنحافظ على تغطية عائلتك",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "لنحافظ على تغطية عائلتك"
    },
    "notKnowingHowToGetCovered": {
      "option": "عدم معرفة كيفية الحصول على التغطية",
      "subtext": "سنرشدك بالضبط لما تحتاجه لضمان تغطية الجميع."
    },
    "notKnowingImCovered": {
      "option": "عدم معرفة من هو مغطى",
      "subtext": "يمكننا التحقق مما إذا كان الجميع لديهم تغطية ومساعدتك في الحصول عليها إذا لم تتوفر.",
      "subtext_RECURRING_WORK_REQUIREMENT": "سنتحقق من تغطية الجميع ونساعدك في الحصول عليها إذا لزم الأمر.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "سنتحقق من تغطية الجميع ونساعدك في الحصول عليها إذا لزم الأمر.",
      "subtext_REDETERMINATION": "سنتحقق من تغطية الجميع ونساعدك في الحصول عليها إذا لزم الأمر.",
      "subtext_REDETERMINATION_awareness": "سنتحقق من تغطية الجميع ونساعدك في الحصول عليها إذا لزم الأمر.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "سنتحقق من تغطية الجميع ونساعدك في الحصول عليها إذا لزم الأمر."
    },
    "paperwork": {
      "option": "الأوراق الكثيرة أو المربكة",
      "subtext": "سنتولى جميع الأوراق للجميع - من التغطية إلى التجديدات.",
      "subtext_SERVICE_INTRODUCTION": "نحن نعمل نيابة عن مقدم الرعاية لعائلتك لإيجاد أفضل خيار لاحتياجات الجميع الصحية."
    },
    "partAB": {
      "option": "الجزء أ و ب (Medicare)",
      "subtext": "سنجد أفضل خيار للجميع، سواء كانت خطتهم الحالية أو Medicare Advantage (الجزء ج)."
    },
    "partABD": {
      "option": "الجزء أ و ب و د (Medicare + الأدوية)",
      "subtext": "سنجد أفضل خيار للجميع، سواء كانت خطتهم الحالية أو Medicare Advantage (الجزء ج)."
    },
    "partC": {
      "option": "الجزء ج (Medicare Advantage)",
      "subtext": "سنتأكد من أن خطة الجميع لا تزال مناسبة لهم."
    },
    "payingForDoctor": {
      "option": "دفع تكاليف زيارات الطبيب والأدوية",
      "subtext": "سنساعد الجميع في العثور على تغطية تخفض تكاليف الزيارات والأدوية."
    },
    "somethingElse": {
      "option": "شيء آخر",
      "subtext": "سنساعد الجميع في الحصول على التغطية والحفاظ عليها.",
      "subtext_AGING_INTO_MEDICARE": "سنرشدك خلال الحصول على Medicare - خطوة بخطوة.",
      "subtext_AGING_INTO_MEDICARE_awareness": "سنرشدك خلال الحصول على Medicare - خطوة بخطوة.",
      "subtext_RECURRING_WORK_REQUIREMENT": "سنساعد الجميع في الحفاظ على تغطيتهم - دون مفاجآت.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "سنساعد الجميع في الحفاظ على تغطيتهم - دون مفاجآت.",
      "subtext_REDETERMINATION": "تخطَّ الأوراق المربكة. سنساعد الجميع على البقاء تحت التغطية.",
      "subtext_REDETERMINATION_awareness": "تخطَّ الأوراق المربكة. سنساعد الجميع على البقاء تحت التغطية.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "تخطَّ الأوراق المربكة. سنساعد الجميع على البقاء تحت التغطية.",
      "subtext_SERVICE_INTRODUCTION_medicare": "سنتأكد من أن خطة الجميع لا تزال مناسبة لهم."
    },
    "submittingRenewals": {
      "option": "تقديم التجديدات",
      "subtext": "سنتولى عمليات التجديد للجميع. كل ما يتطلبه الأمر هو بضعة أسئلة بسيطة."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "الكثير من إعلانات ومكالمات Medicare",
      "subtext": "سنخلصك من هذا الإزعاج ونساعدك في العثور على الخطة المناسبة."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "تساعد Pointcare أكثر من 1.8 مليون مريض في العثور على تغطيتهم الصحية والحفاظ عليها.",
          "firstItem_LAPSE": "اعرف من يتأهل خلال 5 دقائق",
          "infoIsPrivate": "معلوماتك آمنة معنا",
          "title": "تعمل {{clinicName}} مع Pointcare لمساعدة عائلتك"
        },
        "concerns": {
          "description_LAPSE": "اختر ما يهمك أكثر وسنوضح لك كيف يمكننا المساعدة.",
          "title_LAPSE": "ما أصعب شيء في الحصول على تغطية لعائلتك؟"
        },
        "intro": {
          "description_LAPSE": "معظم الناس يتأهلون مجدداً لتغطية مجانية أو منخفضة التكلفة. سنساعدك في كل خطوة.",
          "title_LAPSE": "فقد شخص ما في عائلتك تغطية {{payerName}} في <colorEmphasis>{{lapseDate}}</colorEmphasis>. نحن هنا لمساعدتهم على استعادة التغطية."
        },
        "nextSteps": {
          "step2Description_LAPSE": "اعرف ما تتأهل له عائلتك"
        },
        "paperwork": {
          "option": "أوراق مربكة"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "هل نسيت كلمة المرور الخاصة بك؟",
    "passwordInputLabel": "كلمة المرور",
    "passwordInputPlaceholder": "أدخل كلمة المرور",
    "resetPasswordInstructions": "لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى <bold>{{email}}</bold>. افتحه لإنشاء كلمة مرور جديدة.",
    "subtitle": "يرجى إدخال كلمة المرور الخاصة بحسابك للمتابعة.",
    "title": "أدخل كلمة المرور",
    "usernameResetUnavailable": "لا يمكن إعادة تعيين كلمة المرور بالبريد الإلكتروني لحسابات اسم المستخدم. اتصل بنا وسنساعدك."
  },
  "profileInformationScreen": {
    "addressComplement": "شقة، وحدة، مبنى (اختياري)",
    "checkCoverage": "اختبار التحقق من التغطية",
    "coverageStatus": "حالة التغطية: {{status}}",
    "dateOfBirth": "تاريخ الميلاد",
    "email": "البريد الإلكتروني",
    "firstName": "الاسم الأول",
    "homeAddress": "عنوان السكن",
    "lastName": "اسم العائلة",
    "mailingAddress": "عنوان المراسلة",
    "mailingAddressComplement": "رقم الشقة، الوحدة، المبنى، صندوق البريد (اختياري)",
    "medicaidCaseNumber": "رقم حالة Medicaid (اختياري)",
    "medicaidSubscriberId": "رقم مشترك Medicaid (اختياري)",
    "noHomeAddress": "لا يوجد عنوان سكن ثابت",
    "noMailingAddress": "لا يوجد عنوان مراسلة",
    "phoneNumber": "رقم الهاتف",
    "socialSecurityNumber": "رقم الضمان الاجتماعي",
    "useDifferentMailingAddress": "استخدام عنوان مراسلة مختلف"
  },
  "recheckEligibilityScreen": {
    "button": "إعادة فحص الأهلية",
    "title": "قبل إعادة فحص الأهلية، تأكد من تحديث بيانات أفراد الأسرة."
  },
  "redeterminationScreen": {
    "addressInformation": "تحديث معلومات العنوان",
    "alreadyMailedForm": "أرسلت النموذج بالفعل بالبريد أو أخطط لذلك قريباً",
    "caseNumberDescription": "سنستخدم رقم حالتك لتقديم تجديدك بشكل أسرع!\n\nابحث عنه في نموذج التجديد أو في بريد آخر من وكالة ولايتك بخصوص تغطيتك.",
    "caseNumberDescription_PENDING_FORM": "سنستخدم رقم حالتك لتقديم تجديدك بشكل أسرع!\n\nابحث عنه في البريد الوارد من وكالة ولايتك بخصوص تغطيتك.",
    "caseNumberLabel": "رقم الحالة",
    "caseNumberPlaceholder": "أدخل رقم الحالة",
    "caseNumberTitle": "لنُضِف رقم حالتك (اختياري)",
    "description": "اختر الخيار الأفضل",
    "haventReceivedForm": "لم أستلم نموذجاً بعد",
    "receivedForm": "استلمت نموذجاً وأحتاج مساعدة في إكماله",
    "returnToDashboard": "العودة إلى لوحة التحكم",
    "reviewAddress": "يرجى مراجعة وتأكيد عناوين المنزل والبريد لجميع أفراد الأسرة. يضمن ذلك وصول نموذج التجديد إلى العنوان الصحيح.",
    "successDescription": "تم الاعتناء بتجديدك. سنتواصل معك إذا تغيّر أي شيء.",
    "successDescription_CALL_BACK": "سيتواصل معك فريقنا خلال يوم إلى يومي عمل لإتمام تجديدك.",
    "successDescription_PENDING_FORM": "من المفترض أن يصل نموذج التجديد إلى العنوان المسجّل لدينا. ترقّب البريد والبريد الإلكتروني والرسائل النصية. سنحرص على المتابعة معك قبل الموعد النهائي.",
    "successTitle": "كل شيء جاهز!",
    "successTitle_CALL_BACK": "سنتصل بك قريباً.",
    "successTitle_PENDING_FORM": "كل شيء جاهز!",
    "title": "موعد تجديد التغطية لشخص ما في أسرتك هو {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} تجديدات Medicaid تنتظر مكالمة — تستحق في {{dates}}. راقب هاتفك.",
    "cardAggregated_NOT_STARTED": "{{total}} تجديدات Medicaid بحاجة إلى البدء.",
    "cardAggregated_PENDING_FORM": "ستصل قريباً {{total}} نماذج تجديد Medicaid. تابع البريد والبريد الإلكتروني والرسائل النصية.",
    "cardCompact_PENDING_FORM": "نموذج التجديد سيصل قريباً — يستحق في {{date}}",
    "card_CALL_BACK": "لدى أحد أفراد أسرتك تجديد Medicaid ينتظر مكالمة — يستحق في {{date}}. راقب هاتفك.",
    "card_NOT_STARTED": "لدى أحد أفراد أسرتك تجديد Medicaid يستحق في {{date}}.",
    "card_PENDING_FORM": "سيصل قريباً إلى أحد أفراد أسرتك نموذج تجديد Medicaid — يستحق في {{date}}. تابع البريد والبريد الإلكتروني والرسائل النصية.",
    "due": "يستحق في {{date}}",
    "medicaidRenewals": "تجديدات Medicaid",
    "noRenewals": "لا توجد تجديدات بعد.",
    "startRenewal": "بدء التجديد",
    "status": "معاودة الاتصال",
    "status_CALL_BACK": "تم طلب مكالمة",
    "status_COMPLETED": "مكتمل",
    "status_NOT_STARTED": "لم يبدأ",
    "status_PENDING_FORM": "في انتظار النموذج",
    "title": "التجديدات",
    "updateStatus": "تحديث الحالة"
  },
  "registrationCoverageScreen": {
    "description": "يمكن لـ Pointcare البحث عن تغطية Medicaid الحالية باستخدام المعلومات التي تقدمها أدناه.",
    "title": "دعنا نتحقق من تغطيتك"
  },
  "registrationProfileScreen": {
    "description": "قدم تفاصيل ملفك الشخصي لاستخدامها في الطلبات."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "تأكيد كلمة المرور الجديدة",
    "confirmPasswordInputPlaceholder": "أعد إدخال كلمة المرور الجديدة",
    "invalidResetLink": "رابط إعادة تعيين كلمة المرور غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
    "passwordInputLabel": "كلمة المرور الجديدة",
    "passwordInputPlaceholder": "أدخل كلمة المرور الجديدة",
    "subtitle": "اختر كلمة مرور قوية لم تستخدمها من قبل.",
    "title": "إنشاء كلمة مرور جديدة",
    "updatePasswordButton": "تحديث كلمة المرور"
  },
  "sessionTimedOut": {
    "description": "لحمايتك، قمنا بتسجيل خروجك بسبب عدم النشاط. يرجى تسجيل الدخول مرة أخرى للمتابعة.",
    "loginAgain": "تسجيل الدخول مرة أخرى",
    "title": "لقد تم تسجيل خروجك"
  },
  "sessionTimeout": {
    "countdown": "الوقت المتبقي {{time}}",
    "description": "سيتم تسجيل خروجك قريباً بسبب عدم النشاط. هل تريد البقاء متصلاً؟",
    "logOutNow": "تسجيل الخروج الآن",
    "secureSession": "جلسة آمنة",
    "stayLoggedIn": "البقاء مسجلاً",
    "title": "هل ما زلت هنا؟"
  },
  "signatureField": {
    "signaturePrompt": "ارسم توقيعك"
  },
  "someHouseholdMembersNotUpdated": "لم نتمكن من حفظ التغييرات للجميع. يرجى مراجعة كل فرد من أفراد الأسرة للتأكد من حفظ كل شيء.",
  "support": {
    "callUs": "اتصل بنا",
    "callUsAt": "اتصل بنا على الرقم <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "بدء",
    "cardActionCompact_UPLOAD_DOCUMENTS": "رفع",
    "cardAction_CONTINUE": "متابعة متطلبات العمل",
    "cardAction_START": "بدء متطلبات العمل",
    "cardAction_UPLOAD_DOCUMENTS": "رفع المستندات",
    "cardCompact": "متطلبات عمل Medicaid تستحق في {{date}}",
    "card_CONTINUE": "لدى أحد أفراد أسرتك متطلبات عمل Medicaid تستحق في {{date}}. أكمل التحقق من الأشخاص الذين هم على المسار الصحيح أو المعفيين.",
    "card_START": "لدى أحد أفراد أسرتك متطلبات عمل Medicaid تستحق في {{date}}. تحقق مما إذا كنت على المسار الصحيح أو معفياً.",
    "card_UPLOAD_DOCUMENTS": "لدى أحد أفراد أسرتك متطلبات عمل Medicaid تستحق في {{date}}. ارفع المستندات للبقاء على المسار الصحيح.",
    "caseNumbers": {
      "description": "سنستخدم أرقام الحالات هذه لتقديم المستندات نيابةً عن أسرتك.",
      "descriptionSingle": "سنستخدم رقم الحالة هذا لتقديم مستندات العمل الخاصة بـ {{name}}.",
      "hint": "ابحث عنها في البريد الوارد من وكالة ولايتك بخصوص تغطيتك.",
      "hintSingle": "ابحث عنه في البريد الوارد من وكالة الولاية بخصوص تغطية {{name}}.",
      "memberLabel": "{{name}}",
      "title": "لنُضِف أرقام حالات أسرتك (اختياري)",
      "titleSingle": "لنُضِف رقم حالة {{name}} (اختياري)"
    },
    "confirmation": {
      "completedDescription": "سيراجع فريقنا المعلومات وسيتواصل معك إذا احتجنا إلى أي شيء.",
      "completedTitle": "تهانينا، لقد أكملت <label>متطلبات العمل</label>",
      "description": "يرجى تذكّر إكمال متطلباتك قبل موعد التجديد في {{date}}.",
      "title": "<label>متطلبات العمل</label> قيد التنفيذ",
      "uploadsHint": "يمكنك إكمال رفع المستندات من لوحة التحكم عند فتح المزيد من الأشهر."
    },
    "due": "تستحق في <bold>{{date}}</bold>",
    "exemptions": {
      "description": "اختر كل ما ينطبق",
      "groups": {
        "BENEFITS_AND_COVERAGE": "المزايا والتغطية",
        "CAREGIVING": "تقديم الرعاية",
        "HEALTH_AND_RECOVERY": "الصحة والتعافي",
        "LIFE_SITUATIONS": "ظروف الحياة"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "أحد الوالدين أو مقدم رعاية لطفل عمره 13 عاماً أو أقل",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "مقدم رعاية لشخص ذي إعاقة",
        "FOSTER_YOUTH_UNDER_26": "شاب في الرعاية البديلة حالياً أو سابقاً دون سن 26 عاماً",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "في السجن، أو أُفرج عنه خلال آخر 90 يوماً",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "في برنامج علاج من المخدرات أو الكحول",
        "MEDICALLY_FRAIL": "ضعيف صحياً",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "يستوفي بالفعل متطلبات العمل في SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "غير مسجل في Medicare أو غير مؤهل له",
        "PREGNANT_OR_POSTPARTUM": "حامل أو في فترة ما بعد الولادة (12 شهراً أو أقل)",
        "TRIBAL_MEMBER": "عضو في قبيلة أمريكية أصلية معترف بها فيدرالياً",
        "VETERAN_100_PERCENT_DISABILITY": "محارب قديم بتصنيف إعاقة كلية (100%)"
      },
      "title": "هل ينطبق أي من هذه الإعفاءات؟"
    },
    "hours": {
      "communityService": "خدمة المجتمع",
      "description_completed": "أضف الساعات المكتملة لـ {{name}} في شهر {{month}}. اتركها فارغة إذا لم توجد.",
      "description_expected": "أضف الساعات المتوقعة لـ {{name}} في شهر {{month}}. اتركها فارغة إذا لم توجد.",
      "employment": "التوظيف",
      "employmentHint": "أدخل الساعات والأجر الشهري. سنحوّل الأجر إلى ساعات ونحتسب القيمة الأعلى منهما ضمن المتطلب.",
      "hoursPerMonth": "ساعة / شهر",
      "jobTraining": "التدريب المهني",
      "payPerMonth": "$ / شهر",
      "school": "الدراسة / التلمذة المهنية",
      "title": "الإبلاغ عن ساعات {{name}}",
      "totalHours": "إجمالي الساعات",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "اختر كل ما ينطبق، أو تابع إذا لم ينطبق ذلك على أحد.",
      "everyone": "الجميع هنا",
      "title": "من يكسب ${{amount}} أو أكثر شهرياً؟",
      "titleSingle": "هل يكسب {{name}} ${{amount}} أو أكثر شهرياً؟"
    },
    "medicaidWorkRequirements": "متطلبات عمل Medicaid",
    "nextSteps": {
      "complete": "تم إكمال {{completed}} من {{total}}",
      "description": "إليك ما يحتاج كل شخص إلى تقديمه للحفاظ على تغطيته.",
      "needsMoreHours": "يحتاج إلى {{hours}} ساعة إضافية / شهر",
      "offrampDescription": "للحفاظ على التغطية الصحية، يجب إكمال {{hours}} ساعة من الأنشطة المعتمدة شهرياً. يمكن أن يشمل ذلك التوظيف، أو التدريب المهني، أو الدراسة، أو التلمذة المهنية، و/أو خدمة المجتمع.",
      "opensOn": "يُفتح في {{date}}",
      "proofOfExemption": "إثبات الإعفاء",
      "proofOfWork": "إثبات العمل ({{month}})",
      "reasonHours": "أبلغ عن {{hours}} ساعة / شهر",
      "reasonIncome": "يكسب ${{amount}} أو أكثر شهرياً",
      "reportedOf": "أبلغ عن {{hours}} من {{required}} ساعة / شهر",
      "status_EXEMPT": "معفى",
      "status_MEETS_REQUIREMENTS": "يستوفي المتطلبات",
      "title": "الخطوات التالية لـ <label>متطلبات العمل</label>",
      "volunteerOpportunities": "فرص التطوع"
    },
    "noWorkRequirements": "لا توجد متطلبات عمل لأسرتك.",
    "progress_ACTION_NEEDED": "مطلوب إجراء",
    "progress_COMPLETED": "مكتمل",
    "progress_UP_TO_DATE": "محدّث",
    "recheck": "إعادة التحقق من متطلبات العمل",
    "sectionTitle": "متطلبات العمل",
    "whatAreDescription": "يُلزم قانون فيدرالي جديد بعض البالغين المشمولين بـ Medicaid بالعمل، أو التدريب على وظيفة، أو الدراسة، أو التطوع لمدة {{hours}} ساعة شهرياً. ينطبق هذا فقط على البالغين الذين تتراوح أعمارهم بين {{minAge}} و{{maxAge}} عاماً.",
    "who": {
      "checkAll": "التحقق من جميع أفراد الأسرة",
      "noEligibleMembers": "لا يوجد أحد في أسرتك يتراوح عمره بين {{minAge}} و{{maxAge}} عاماً، لذلك لا يحتاج أحد إلى التحقق.",
      "question": "<bold>من تريد التحقق منه؟ سنرى ما إذا كانوا على المسار الصحيح أو معفيين وسندعمك من هناك.</bold>",
      "title": "التحقق من حالة <label>متطلبات العمل</label> للأسرة"
    }
  }
}
